<script setup>
import { ref, reactive, getCurrentInstance } from 'vue';
import ChangeCat from '@/components/common/changeCat.vue';

const app = getCurrentInstance().proxy;

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits('clear', 'success');

const search = {
  backendCategoryId: undefined,
  start: undefined,
  relationGoodsId: undefined,
  relationGoodsName: undefined,
  currentPage: 1,
  nowPageSize: 10,
  count: 0,
};
const params = reactive({ ...search });
const loading = ref(false);
const tableData = ref([]);
const updateList = ref([]);
const multipleTable = ref(null);
const expandRowKeys = ref([]);

// 新增：弹窗相关变量
const showPriceDialog = ref(false);
const priceDialogData = reactive({
  row: null, // 当前操作的sku
  mode: 1, // 1: 直接设置, 2: 佣金比例
  directPrice: null,
  percent: null,
  sellPrice: null,
});

function openPriceDialog(sku, sellPrice) {
  console.log(sku,'sku')
  priceDialogData.row = sku;
    priceDialogData.mode = sku.supplyType || 1; // 根据sku.supplyType判断
    priceDialogData.supplyPrice = sku.supplyPrice || '';
    priceDialogData.editPrice = sku.editPrice || '';
    priceDialogData.sellPrice = sku.sellPrice;
    if(sku.supplyType==1){
      priceDialogData.directPrice = sku.supplyPrice || '';
      priceDialogData.percent = '';
    }else{
      priceDialogData.percent = sku.supplyPercent ? Number((sku.supplyPercent * 100).toFixed(0)) : '';
      priceDialogData.directPrice =  '';
    }
    // priceDialogData.row.supplyPercent = sku.supplyPercent*0.01; // 设置百分比
    showPriceDialog.value = true;
}

function handlePercentInput(value) {
  // 只允许输入整数，不允许小数，限制范围0-100
  if (value !== '' && value !== null && value !== undefined) {
    let numValue = Number(value);
    
    // 如果是小数，转换为整数
    if (value.toString().includes('.')) {
      numValue = Math.floor(numValue);
    }
    
    // 限制范围0-100
    if (numValue < 0) {
      numValue = 0;
    } else if (numValue > 100) {
      numValue = 100;
    }
    
    priceDialogData.percent = numValue;
  }
}

function handlePriceDialogOk() {
  if (priceDialogData.mode === 1) {
    // 直接设置
    if (!priceDialogData.directPrice && priceDialogData.directPrice !== 0) {
      app.$message.error('请设置供货价');
      return;
    }
    // 供货价大于售价时，点击确定，提示 供货价≤售价
    if (priceDialogData.directPrice > priceDialogData.sellPrice) {
      app.$message.error('供货价≤售价');
      return;
    }
    priceDialogData.row.supplyPrice = Number(priceDialogData.directPrice);
    priceDialogData.row.editPrice = Number(priceDialogData.directPrice);
    // 供货类型0无供货价，1按价格，2按佣金比例
    priceDialogData.row.supplyType = 1;
  } else {
    // 佣金比例
    if (priceDialogData.percent === '' || priceDialogData.percent === null) {
      app.$message.error('请设置佣金比例');
      return;
    }
    const percent = Number(priceDialogData.percent) / 100;
    const price = priceDialogData.sellPrice * (1 - percent);
    priceDialogData.row.supplyPrice = Number(price.toFixed(2));
    priceDialogData.row.editPrice = Number(price.toFixed(2));
    // 供货类型0无供货价，1按价格，2按佣金比例
    priceDialogData.row.supplyType = 2;
    // 供货比例 提供给后端转小数点
    priceDialogData.row.supplyPercent = priceDialogData.percent*0.01;
  }
  showPriceDialog.value = false;
}

function handleClose() {
  emit('clear');
}
function submit() {
  const list = multipleTable.value.selection;
  if (!list.length) {
    app.$message.error('请勾选商品');
    return;
  }
  if (list.length > 100) {
    app.$message.error('最多选择100个商品');
    return;
  }
  let loopSwitch = true;
  goodsLoop: for (const goods of list) {
    for (const sku of goods.tradeGoodsSkuDtoList) {
      if ((!sku.editPrice || sku.editPrice === 0) && !sku.supplyPrice) {
        app.$message.error(`商品（${goods.relationGoodsName}）未设置供货价`);
        loopSwitch = false;
        break goodsLoop;
      }
      if (sku.editPrice > sku.sellPrice) {
        app.$message.error(`商品（${goods.relationGoodsName}）供货价不能大于销售价`);
        loopSwitch = false;
        break goodsLoop;
      }
      if(sku.editPrice)sku.supplyPrice = sku.editPrice;
    }
  }
  if (loopSwitch) {
    const params = list;
    app.$confirm('是否确认提交?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(async () => {
      const res = await app.$axios.post(app.$api.supplychain.add, params);
      if (res.code !== 0) return;
      app.$message.success('操作成功！');
      emit('success');
      handleClose();
    }).catch(() => {});
  }
}

function handleChange(value) {
  if (value && value.length > 0) {
    params.backendCategoryId = value[value.length - 1];
  } else {
    params.backendCategoryId = '';
  }
}
// 分页控制
function handleSizeChange(val) {
  params.nowPageSize = val;
  params.currentPage = 1;
  getList();
}
function handleCurrentChange(val) {
  params.currentPage = val;
  getList();
}
async function getList(num) {
  if (num) params.currentPage = num;
  loading.value = true;
  const res = await app.$axios.post(app.$api.supplychain.pageForAdd, {
    ...params,
    currentPage: params.currentPage,
    pageSize: params.nowPageSize,
    nowPageSize: undefined,
    count: undefined,
  });
  loading.value = false;
  if (res.code === 0) {
    tableData.value = res.data.records;
    params.count = Number(res.data.total);
  }
}
function operation() {
  for (const key in search) {
    params[key] = search[key];
  }
  getList(1);
}

// 禁用
function checkboxTrue(row) {
  return +row.isAdded === 0; // 不禁用
}
function selectionChange(selection) {
  expandRowKeys.value = selection.map((item) => item.relationGoodsId);
}
function open() {
  updateList.value = [];
  if (multipleTable.value && multipleTable.value.clearSelection) {
    multipleTable.value.clearSelection();
  }
  getList(1);
}
</script>

<template>
  <div>
    <el-dialog
      title="添加供货商品"
      :visible.sync="props.show"
      width="1000px"
      :before-close="handleClose"
      @open="open"
    >
      <div>
        <template>
          <div class="outer supply-chain">
            <search-panel
              show-btn
              flex
              @getList="getList(1)"
            >
              <div>
                <p>商品类目</p>
                <ChangeCat
                  :parent-id="1"
                  @change="handleChange"
                />
              </div>
              <!-- <div>
                <p>供货状态</p>
                <el-select
                  v-model="params.start"
                  placeholder="请选择状态"
                  size="mini"
                  clearable
                  @change="getList(1)"
                >
                  <el-option
                    label="供货中"
                    :value="1"
                  />
                  <el-option
                    label="未供货"
                    :value="0"
                  />
                </el-select>
              </div> -->
              <div>
                <p>商品ID</p>
                <el-input-number
                  v-model="params.relationGoodsId"
                  size="mini"
                  :controls="false"
                  :min="0"
                  :precision="0"
                  placeholder="请输入内容"
                  clearable
                />
              </div>
              <div>
                <p>商品名称</p>
                <el-input
                  v-model="params.relationGoodsName"
                  clearable
                  placeholder="请输入内容"
                  size="mini"
                  @clear="getList(1)"
                />
              </div>

              <el-button
                slot="button-right"
                size="mini"
                @click="operation()"
              >
                重 置
              </el-button>
            </search-panel>
            <el-table
              ref="multipleTable"
              v-loading="loading"
              :data="tableData"
              element-loading-text="拼命加载中"
              style="width: 100%"
              row-key="relationGoodsId"
              :header-cell-style="{
                background: '#f5f7fa',
              }"
              size="medium"
              :expand-row-keys="expandRowKeys"
              @selection-change="selectionChange"
            >
              <el-table-column
                type="selection"
                width="55"
                :reserve-selection="true"
                :selectable="checkboxTrue"
              />
              <el-table-column type="expand">
                <template slot-scope="{row}">
                  <el-table
                    :data="row.tradeGoodsSkuDtoList"
                    style="margin-left: 103px"
                    size="medium"
                  >
                    <el-table-column
                      label="商品规格"
                      width="300"
                    >
                      <template slot-scope="prop">
                        <div class="wd-flex wd-flex-align-center">
                          <el-image
                            style="width: 50px; height: 50px"
                            :src="prop.row.imageIds"
                            :preview-src-list="[prop.row.imageIds]"
                            fit="cover"
                          />
                          <div class="margin-l5">
                            {{ prop.row.specValue }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="店铺销售价"
                      width="180"
                    >
                      <template slot-scope="scope">
                        {{ +scope.row.sellPrice }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="supplyPrice"
                      label="供货价"
                    >
                      <template slot-scope="prop">
                        <span>{{ prop.row.supplyPrice !== undefined && prop.row.supplyPrice !== null ? prop.row.supplyPrice : '-' }}</span>
                        <span v-if="prop.row.supplyType">{{ prop.row.supplyType==1?`（直接设置）`:`（以佣金比例${Number((prop.row.supplyPercent*100).toFixed(0))}%设置）`}}</span>
                        <i
                          class="el-icon-edit"
                          style="margin-left: 8px; cursor: pointer; color: #409EFF;"
                          @click="openPriceDialog(prop.row, prop.row.sellPrice)"
                        ></i>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column
                prop="isAdded"
                label="状态"
                width="100"
              >
                <template slot-scope="{row}">
                  {{ +row.isAdded === 1 ? '已添加' : '未添加' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="relationGoodsId"
                label="商品ID"
                width="100"
              />
              <el-table-column
                prop="relationGoodsName"
                label="商品名称"
              />
              <el-table-column
                prop="backendCategoryPath"
                label="商品类目"
              />
            </el-table>
            <el-pagination
              v-if="tableData && tableData.length > 0"
              :current-page="params.currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="params.nowPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="params.count"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </template>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="small"
          @click="handleClose"
        >取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submit"
        >添加选中项</el-button>
      </span>
    </el-dialog>

    <!-- 新增弹窗 -->
    <el-dialog
      title="设置供货价"
      :visible.sync="showPriceDialog"
      width="400px"
    >
      <el-radio-group v-model="priceDialogData.mode" style="margin-bottom: 16px;">
        <el-radio :label="1">直接设置</el-radio>
        <el-radio :label="2">以佣金比例设置</el-radio>
      </el-radio-group>
      <div v-if="priceDialogData.mode === 1">
        <div style="margin-bottom: 8px;">供货价</div>
        <el-input-number
          v-model="priceDialogData.directPrice"
          :min="0"
          :precision="2"
          placeholder="请设置供货价"
          style="width: 100%;"
        />
      </div>
      <div v-else>
        <div style="margin-bottom: 8px;">供货价 = 售价 × (1 - 佣金比例)</div>
        <el-input
          v-model="priceDialogData.percent"
          type="number"
          :min="0"
          :max="100"
          placeholder="请输入佣金比例"
          style="width: 100%;"
          @input="handlePercentInput"
        >
          <template slot="append">%</template>
        </el-input>
        <div style="margin-top: 8px; color: #888;">
          供货价= {{ priceDialogData.sellPrice ? (priceDialogData.sellPrice * (1 - (Number(priceDialogData.percent || 0) / 100))).toFixed(2) : '-' }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPriceDialog = false">取消</el-button>
        <el-button type="primary" @click="handlePriceDialogOk">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.input_box :deep(input) {
  border-color: red;
}
</style>
